exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table td[data-v-9a9100a0],.table th[data-v-9a9100a0]{vertical-align:middle}", ""]);

// exports
